import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Notification, NotificationCreate, NotificationFilter } from '../data/notification';

export function createNotificationService(client: AxiosInstance) {
  return createCrudService<Notification, NotificationCreate, NotificationFilter>(
    client,
    '/notifications/Notification',
    'id',
  );
}

export type NotificationService = CrudService<Notification, NotificationCreate, NotificationFilter>;
